import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Card, Layout, OuterInend, UserContainerInfo, ActivityText, CaptureContainer, TitleText } from './style';
//components
import { Text } from '../../UI/Text';
import { Icon } from '../Icons/Icons';
import { ProfileAvatar } from '../ProfileAvatar/ProfileAvatar';
//layouts
import { Row, Column } from '../../Layouts';
import WeightPng from '../../../Assets/Icons/weight.png';
import CaloriesPng from '../../../Assets/Icons/calories.png';
import RepsPng from '../../../Assets/Icons/reps.png';
import TimePng from '../../../Assets/Icons/time.png';
import DistanceIcon from '../../../Assets/Icons/LeaderboardIcons/distance.png';
import { OuterIndend } from '../../UI/Indends';
import {
    generateSlugLink,
    displayActivityCardMetric,
    displayActivityCardMetricValue,
    roundNumber,
} from '../../../Utils';
import getWorkoutType from '../../../Utils/workoutType';
import { displayTime, displaySelectedTime, getCustomSeparatedTime } from '../../../Utils/timeConvertorHelper';
import styled from 'styled-components';
import { getFormattedTimePassed } from '../../../Utils/timeConvertorHelper';
import { config } from '../../../Configurations';

const Overlay = styled.div`
    width: 100%;
    height: 100%;
    padding: 10px 10px;

    position: relative;
`;

const DisplayCondition = ({ condition, children }) => {
    return condition ? children : null;
};

const OverlayWithIcon = function({ children }) {
    return (
        <Overlay>
            <div
                style={{
                    position: 'absolute',
                    right: '2px',
                    top: '2px',
                    zIndex: 1,
                }}
            >
                <Icon.Box size={'20x20'}>
                    <Icon.SmallLogo />
                </Icon.Box>
            </div>
            <div
                style={{
                    position: 'relative',
                    zIndex: 11,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {children}
            </div>
        </Overlay>
    );
};

function OwnerActivity({
    user: { fullName, smallImage, id },
    capture,
    createdAt,
    withoutHeader,
    repeat,
    workoutType,
    userLocation,
    ...props
}) {
    const getTitle = () => {
        if (userLocation) return userLocation;

        if (repeat) {
            const { fullName } = repeat.user;
            return `Repeated ${fullName}'s ${getWorkoutType(workoutType)} workout`;
        }

        return capture;
    };

    return withoutHeader ? null : (
        <Link
            to={`/${generateSlugLink({
                id,
                name: fullName,
            })}`}
        >
            <UserContainerInfo>
                <Row width="100%" align={'center'}>
                    <ProfileAvatar src={`${config.baseUrl}/${smallImage}`} />
                    <Column width="90%">
                        <Row width="100%" justify={'space-between'}>
                            <OuterInend margin={'0 0 0 10px'} width={'145px'}>
                                <Text
                                    small
                                    weight={'bold'}
                                    opacity={0.7}
                                    textOverflow={'ellipsis'}
                                    nowrap
                                    overflow={'hidden'}
                                >
                                    {fullName}
                                </Text>
                            </OuterInend>
                            <Text opacity={0.5} fontSize={9} weight={300}>
                                {getFormattedTimePassed(createdAt)}
                            </Text>
                        </Row>
                        <CaptureContainer>
                            <OuterInend margin={'0 5px 0 10px'}>
                                <OuterInend margin={'4px 0 0 0'} weight={'300'}>
                                    <Text
                                        textOverflow={'ellipsis'}
                                        nowrap
                                        overflow={'hidden'}
                                        opacity={0.5}
                                        fontSize={10}
                                        weight={300}
                                        lineHeight={1.4}
                                    >
                                        {getTitle()}
                                    </Text>
                                </OuterInend>
                            </OuterInend>
                        </CaptureContainer>
                    </Column>
                </Row>
            </UserContainerInfo>
        </Link>
    );
}

OwnerActivity = withRouter(OwnerActivity);
OwnerActivity.defaultProps = {
    user: {},
};

const Basic = ({
    activity: {
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => {
    //TODO: / props.activity.image.data.original_url
    return (
        <React.Fragment>
            <OwnerActivity
                withoutHeader={withoutHeader}
                user={user}
                capture={title}
                createdAt={createdAt}
                workoutType={workoutType}
                repeat={repeat}
                userLocation={userLocation}
            />
            <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
                <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                    <OverlayWithIcon />
                </Card>
            </ConditionalLinkWrapper>
        </React.Fragment>
    );
};

const LeftAlignment = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => {
    //TODO: / props.activity.image.data.original_url
    return (
        <React.Fragment>
            <OwnerActivity
                withoutHeader={withoutHeader}
                user={user}
                capture={title}
                createdAt={createdAt}
                repeat={repeat}
                workoutType={workoutType}
                userLocation={userLocation}
            />
            <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
                <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                    <OverlayWithIcon>
                        <Layout column justify={'center'}>
                            <OuterInend>
                                <Row>
                                    <Icon.Box size={'16x16'}>
                                        <Icon.Time />
                                    </Icon.Box>
                                    <ActivityText>{displayTime(totalTime)}</ActivityText>
                                </Row>
                            </OuterInend>

                            <DisplayCondition condition={totalReps > 1}>
                                <OuterInend>
                                    <Row>
                                        <Icon.Box size={'16x16'}>
                                            <Icon.Reps />
                                        </Icon.Box>
                                        <ActivityText>{totalReps} reps</ActivityText>
                                    </Row>
                                </OuterInend>
                            </DisplayCondition>

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <OuterInend>
                                    <Row>
                                        <Icon.Box size={'16x16'}>
                                            <Icon.Weight />
                                        </Icon.Box>
                                        <ActivityText>
                                            {displayActivityCardMetric(totalKgLifted, metric)} lifted
                                        </ActivityText>
                                    </Row>
                                </OuterInend>
                            </DisplayCondition>

                            <DisplayCondition condition={totalCalories > 0}>
                                <OuterInend>
                                    <Row>
                                        <Icon.Box size={'16x16'}>
                                            <Icon.Calories />
                                        </Icon.Box>
                                        <ActivityText>{totalCalories} Calories</ActivityText>
                                    </Row>
                                </OuterInend>
                            </DisplayCondition>

                            {totalBpm !== null &&
                                totalBpm !== 0 && (
                                    <OuterInend>
                                        <Row>
                                            <Icon.Box size={'16x16'}>
                                                <Icon.Headerate />
                                            </Icon.Box>
                                            <ActivityText>{totalBpm} av.bpm</ActivityText>
                                        </Row>
                                    </OuterInend>
                                )}
                        </Layout>
                        <TitleText>{title}</TitleText>
                    </OverlayWithIcon>
                </Card>
            </ConditionalLinkWrapper>
        </React.Fragment>
    );
};

const CenterAlignment = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'center'} align={'center'}>
                        <OuterInend>
                            <Row>
                                <ActivityText>{displayTime(totalTime)}</ActivityText>
                            </Row>
                        </OuterInend>

                        <DisplayCondition condition={totalReps > 1}>
                            <OuterInend>
                                <Row>
                                    <ActivityText>{totalReps} reps</ActivityText>
                                </Row>
                            </OuterInend>
                        </DisplayCondition>

                        <DisplayCondition condition={totalKgLifted > 0}>
                            <OuterInend>
                                <Row>
                                    <ActivityText>
                                        {displayActivityCardMetric(totalKgLifted, metric)} lifted
                                    </ActivityText>
                                </Row>
                            </OuterInend>
                        </DisplayCondition>

                        <DisplayCondition condition={totalCalories > 0}>
                            <OuterInend>
                                <Row>
                                    <ActivityText>{totalCalories} Calories</ActivityText>
                                </Row>
                            </OuterInend>
                        </DisplayCondition>

                        {totalBpm !== null &&
                            totalBpm !== 0 && (
                                <OuterInend>
                                    <Row>
                                        <ActivityText>{totalBpm} av.bpm</ActivityText>
                                    </Row>
                                </OuterInend>
                            )}
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const RightAlignment = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'center'} align={'flex-end'}>
                        <OuterInend>
                            <Row>
                                <ActivityText>{displayTime(totalTime)}</ActivityText>
                                <Icon.Box size={'16x16'}>
                                    <Icon.Time />
                                </Icon.Box>
                            </Row>
                        </OuterInend>

                        <DisplayCondition condition={totalReps > 1}>
                            <OuterInend>
                                <Row>
                                    <ActivityText>{totalReps} reps</ActivityText>
                                    <Icon.Box size={'16x16'}>
                                        <Icon.Reps />
                                    </Icon.Box>
                                </Row>
                            </OuterInend>
                        </DisplayCondition>

                        <DisplayCondition condition={totalKgLifted > 0}>
                            <OuterInend>
                                <Row>
                                    <ActivityText>
                                        {displayActivityCardMetric(totalKgLifted, metric)} lifted
                                    </ActivityText>
                                    <Icon.Box size={'16x16'}>
                                        <Icon.Weight />
                                    </Icon.Box>
                                </Row>
                            </OuterInend>
                        </DisplayCondition>

                        <DisplayCondition condition={totalCalories > 0}>
                            <OuterInend>
                                <Row>
                                    <ActivityText>{totalCalories} Calories</ActivityText>
                                    <Icon.Box size={'16x16'}>
                                        <Icon.Calories />
                                    </Icon.Box>
                                </Row>
                            </OuterInend>
                        </DisplayCondition>

                        {totalBpm !== null &&
                            totalBpm !== 0 && (
                                <OuterInend>
                                    <Row>
                                        <ActivityText>{totalBpm} av.bpm</ActivityText>
                                        <Icon.Box size={'16x16'}>
                                            <Icon.Headerate />
                                        </Icon.Box>
                                    </Row>
                                </OuterInend>
                            )}
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

function Circle({ children, ...props }) {
    return (
        <Column width={'25%'} height={'auto'} alignCenter>
            {children}
        </Column>
    );
}

const Circles = ({
    activity: {
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'flex-end'}>
                        <Row justify={'flex-start'}>
                            <DisplayCondition condition={totalCalories > 0}>
                                <Circle>
                                    <Icon.Box size={'14x14'}>
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>

                                    <OuterIndend indend={['2', '0']}>
                                        <ActivityText textAlign={'center'} size={'18px'}>
                                            {totalCalories}
                                        </ActivityText>
                                    </OuterIndend>

                                    <ActivityText tiny>Calories</ActivityText>
                                </Circle>
                            </DisplayCondition>

                            <DisplayCondition condition={totalTime > 0}>
                                <Circle>
                                    <Icon.Box size={'14x14'}>
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <OuterIndend indend={['2', '0']}>
                                        <ActivityText textAlign={'center'} size={'18px'}>
                                            {displaySelectedTime(totalTime)}
                                        </ActivityText>
                                    </OuterIndend>
                                    <ActivityText tiny>Time</ActivityText>
                                </Circle>
                            </DisplayCondition>

                            <DisplayCondition condition={totalReps > 1}>
                                <Circle>
                                    <Icon.Box size={'14x14'}>
                                        <img alt={'Reps'} src={RepsPng} />
                                    </Icon.Box>
                                    <OuterIndend indend={['2', '0']}>
                                        <ActivityText textAlign={'center'} size={'18px'}>
                                            {totalReps}
                                        </ActivityText>
                                    </OuterIndend>
                                    <ActivityText tiny>Reps</ActivityText>
                                </Circle>
                            </DisplayCondition>

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <Circle>
                                    <Icon.Box size={'14x14'}>
                                        <img alt={'Weight'} src={WeightPng} />
                                    </Icon.Box>
                                    <OuterIndend indend={['2', '0']}>
                                        <ActivityText textAlign={'center'} size={'18px'}>
                                            {displayActivityCardMetric(totalKgLifted, metric, true)}
                                        </ActivityText>
                                    </OuterIndend>
                                    <ActivityText tiny>{metric ? 'kg' : 'lbs'} lifted</ActivityText>
                                </Circle>
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const Calories = ({
    activity: {
        totalCalories,
        totalKgLifted,
        totalTime,
        totalBpm,
        metric,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'space-between'}>
                        <div>
                            <OuterInend margin={'0 0 5px 0'}>
                                <Icon.Box size={'24x24'} margin="0px">
                                    <img alt={'Calories'} src={CaloriesPng} />
                                </Icon.Box>
                            </OuterInend>

                            <ActivityText size={'28px'}>{totalCalories}</ActivityText>
                            <ActivityText size={'16px'}>Calories</ActivityText>
                        </div>

                        <Row>
                            <Row align={'center'}>
                                <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                    <img alt={'Time'} src={TimePng} />
                                </Icon.Box>
                                <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                            </Row>
                            <OuterIndend indend={'0 10px 0 0'} />

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Weight'} src={WeightPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>
                                        {displayActivityCardMetric(totalKgLifted, metric)} lifted
                                    </ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalBpm > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <Icon.Headerate />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                </Row>
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const Reps = ({
    activity: {
        totalReps,
        totalKgLifted,
        totalTime,
        totalBpm,
        metric,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={totalReps > 10 ? 'space-between' : 'flex-end'}>
                        <DisplayCondition condition={totalReps > 10}>
                            <div>
                                <OuterInend margin={'0 0 5px 0'}>
                                    <Icon.Box size={'24x24'} margin="0px">
                                        <img alt={'Reps'} src={RepsPng} />
                                    </Icon.Box>
                                </OuterInend>

                                <ActivityText size={'28px'}>{totalReps}</ActivityText>
                                <ActivityText size={'16px'}>Reps</ActivityText>
                            </div>
                        </DisplayCondition>

                        <div>
                            <Row>
                                <DisplayCondition condition={totalKgLifted > 0}>
                                    <Row align={'center'}>
                                        <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                            <img alt={'Weight'} src={WeightPng} />
                                        </Icon.Box>
                                        <ActivityText tiny>
                                            {displayActivityCardMetric(totalKgLifted, metric)}
                                        </ActivityText>
                                    </Row>
                                    <OuterIndend indend={'0 10px 0 0'} />
                                </DisplayCondition>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                                <DisplayCondition condition={totalBpm > 0}>
                                    <Row align={'center'}>
                                        <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                            <Icon.Headerate />
                                        </Icon.Box>
                                        <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                    </Row>
                                </DisplayCondition>
                            </Row>
                        </div>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const Load = ({
    activity: {
        totalKgLifted,
        totalBpm,
        totalCalories,
        totalTime,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => {
    const weightValue = displayActivityCardMetricValue(totalKgLifted, metric);

    return (
        <React.Fragment>
            <OwnerActivity
                withoutHeader={withoutHeader}
                user={user}
                createdAt={createdAt}
                capture={title}
                workoutType={workoutType}
                repeat={repeat}
                userLocation={userLocation}
            />
            <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
                <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                    <OverlayWithIcon>
                        <Layout column justify={totalKgLifted > 0 ? 'space-between' : 'flex-end'}>
                            <DisplayCondition condition={totalKgLifted > 0}>
                                <div>
                                    <OuterInend margin={'0 0 5px 0'}>
                                        <Icon.Box size={'24x24'} margin="0px">
                                            <img alt={'Weight'} src={WeightPng} />
                                        </Icon.Box>
                                    </OuterInend>

                                    <OuterInend>
                                        <ActivityText size={'28px'}>
                                            {weightValue.kgs ? weightValue.kgs : weightValue.lbs}
                                        </ActivityText>
                                        <ActivityText size={'16px'}>
                                            {weightValue.kgs ? `Kgs` : `${weightValue.lbs === 1 ? 'lb' : 'lbs'}`}
                                        </ActivityText>
                                    </OuterInend>
                                </div>
                            </DisplayCondition>

                            <Row>
                                <DisplayCondition condition={totalCalories > 0}>
                                    <Row align={'center'}>
                                        <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                            <img alt={'Calories'} src={CaloriesPng} />
                                        </Icon.Box>
                                        <ActivityText tiny>{totalCalories} calories</ActivityText>
                                    </Row>
                                </DisplayCondition>
                                <OuterIndend indend={'0 10px 0 0'} />
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                                <DisplayCondition condition={totalBpm > 0}>
                                    <Row align={'center'}>
                                        <Icon.Box size={'10x10'}>
                                            <Icon.Headerate />
                                        </Icon.Box>
                                        <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                    </Row>
                                </DisplayCondition>
                            </Row>
                        </Layout>
                        <TitleText>{title}</TitleText>
                    </OverlayWithIcon>
                </Card>
            </ConditionalLinkWrapper>
        </React.Fragment>
    );
};

const Duration = ({
    activity: {
        totalTime,
        totalKgLifted,
        totalCalories,
        totalBpm,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        size,
        withoutHeader,
        metric,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'space-between'}>
                        <div>
                            <OuterInend margin={'0 0 5px 0'}>
                                <Icon.Box size={'24x24'} margin="0px">
                                    <Icon.Time />
                                </Icon.Box>
                            </OuterInend>
                            <ActivityText size={'28px'}>{getCustomSeparatedTime(totalTime, ':')}</ActivityText>
                            <ActivityText size={'16px'}>Duration</ActivityText>
                        </div>

                        <Row>
                            <DisplayCondition condition={totalCalories > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalCalories} calories</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>
                            <DisplayCondition condition={totalBpm > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'}>
                                        <Icon.Headerate />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                </Row>
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const Distance = ({
    activity: {
        total_distance,
        totalTime,
        totalBpm,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={total_distance > 0.1 ? 'space-between' : 'flex-end'}>
                        <DisplayCondition condition={total_distance > 0.1}>
                            <div>
                                <OuterInend margin={'0 0 5px 0px'}>
                                    <Icon.Box size={'18x24'} margin="0px">
                                        <img alt={'Distance'} src={DistanceIcon} />
                                    </Icon.Box>
                                </OuterInend>
                                <ActivityText size={'28px'}>{roundNumber(total_distance, 1)}</ActivityText>
                                <ActivityText size={'16px'}>Km</ActivityText>
                            </div>
                        </DisplayCondition>

                        <Row>
                            <DisplayCondition condition={totalCalories > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalCalories} calories</ActivityText>
                                </Row>
                            </DisplayCondition>

                            <DisplayCondition condition={totalTime > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'}>
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalBpm > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <Icon.Headerate />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                </Row>
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const Bpm = ({
    activity: {
        totalBpm,
        totalCalories,
        totalKgLifted,
        totalTime,
        id,
        metric,
        user,
        createdAt,
        mediumImage,
        title,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={totalBpm && totalBpm > 0 ? 'space-between' : 'flex-end'}>
                        <DisplayCondition condition={totalBpm && totalBpm > 0}>
                            <div>
                                <OuterInend margin={'0 0 10px 0'}>
                                    <Icon.Box size={'24x24'} margin="0px 5px 0px 0px">
                                        <Icon.Headerate />
                                    </Icon.Box>
                                </OuterInend>
                                <ActivityText size={'28px'}>{totalBpm}</ActivityText>
                                <ActivityText size={'16px'}>BPM</ActivityText>
                            </div>
                        </DisplayCondition>

                        <Row>
                            <DisplayCondition condition={totalTime > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalCalories > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalCalories} calories</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Weight'} src={WeightPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>
                                        {displayActivityCardMetric(totalKgLifted, metric)} lifted
                                    </ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const BottomRepsStats = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />

        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'flex-end'}>
                        <Row>
                            <DisplayCondition condition={totalCalories > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalCalories} calories</ActivityText>
                                </Row>
                            </DisplayCondition>

                            <DisplayCondition condition={totalTime > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <Icon.Headerate />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                </Row>

                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const MiddleRepsStats = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'center'}>
                        <Row>
                            <DisplayCondition condition={totalCalories > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalCalories} calories</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalTime > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <Icon.Headerate />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                </Row>

                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const TopRepsStats = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        mediumImage,
        title,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'flex-start'}>
                        <Row>
                            <DisplayCondition condition={totalTime > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Time'} src={TimePng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{displayTime(totalTime)}</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalCalories > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <img alt={'Calories'} src={CaloriesPng} />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalCalories} calories</ActivityText>
                                </Row>
                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>

                            <DisplayCondition condition={totalKgLifted > 0}>
                                <Row align={'center'}>
                                    <Icon.Box size={'10x10'} margin="0px 5px 0px 0px">
                                        <Icon.Headerate />
                                    </Icon.Box>
                                    <ActivityText tiny>{totalBpm} bpm</ActivityText>
                                </Row>

                                <OuterIndend indend={'0 10px 0 0'} />
                            </DisplayCondition>
                        </Row>
                    </Layout>
                    <TitleText>{title}</TitleText>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const TextOnly = ({
    activity: {
        totalBpm,
        totalReps,
        totalKgLifted,
        totalTime,
        totalCalories,
        id,
        user,
        createdAt,
        title,
        mediumImage,
        metric,
        size,
        withoutHeader,
        hasLink,
        repeat,
        workoutType,
        location: userLocation = null,
    },
    match,
    ...props
}) => (
    <React.Fragment>
        <OwnerActivity
            withoutHeader={withoutHeader}
            user={user}
            createdAt={createdAt}
            capture={title}
            workoutType={workoutType}
            repeat={repeat}
            userLocation={userLocation}
        />
        <ConditionalLinkWrapper hasLink={hasLink} path={`${match.url}/workout/${id}`}>
            <Card size={size} src={`${config.baseUrl}/${mediumImage}`}>
                <OverlayWithIcon>
                    <Layout column justify={'flex-end'}>
                        <TitleText>{title}</TitleText>
                    </Layout>
                </OverlayWithIcon>
            </Card>
        </ConditionalLinkWrapper>
    </React.Fragment>
);

const ConditionalLinkWrapper = ({ hasLink, path, children }) => {
    return hasLink ? <Link to={path}>{children}</Link> : <React.Fragment>{children}</React.Fragment>;
};

export class Activity extends PureComponent {
    static Default = withRouter(props => <Basic {...props} />);
    static LeftAlignment = withRouter(props => <LeftAlignment {...props} />);
    static CenterAlignment = withRouter(props => <CenterAlignment {...props} />);
    static RightAlignment = withRouter(props => <RightAlignment {...props} />);
    static Circles = withRouter(props => <Circles {...props} />);
    static Calories = withRouter(props => <Calories {...props} />);
    static Reps = withRouter(props => <Reps {...props} />);
    static Load = withRouter(props => <Load {...props} />);
    static Duration = withRouter(props => <Duration {...props} />);
    static Distance = withRouter(props => <Distance {...props} />);
    static Bpm = withRouter(props => <Bpm {...props} />);
    static BottomRepsStats = withRouter(props => <BottomRepsStats {...props} />);
    static MiddleRepsStats = withRouter(props => <MiddleRepsStats {...props} />);
    static TopRepsStats = withRouter(props => <TopRepsStats {...props} />);
    static TextOnly = withRouter(props => <TextOnly {...props} />);

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/ActivityCard/ActivityCard.js